/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.itealpos
 * @name QaIdealposItemsalesreportCtrl
 * @description A report that replicates the Product summary from the Bepoz back office
 */
angular.module('mercury.modules.qa.idealpos.itemsalesreport')
.controller('QaIdealposItemsalesreportCtrl', ["$filter", "ItemsalesReport", "reporttime", "$q", "$scope", "$stateParams", "title", function($filter, ItemsalesReport, reporttime, $q, $scope, $stateParams, title) {
  reporttime.setAllowedTypes(['day', 'week', 'month', 'year', 'yesterday', 'custom']);
  reporttime.defaultType = 'day';

  title.set('Financial Report');

  $scope.startTime = reporttime.start();
  $scope.endTime = reporttime.end();

  var loadingPromises = {
    report: ItemsalesReport.getReport($scope.startTime, $scope.endTime)
  };

  $scope.loading = $q.all(loadingPromises);
  $scope.loading.then(function(result) {
    var groups = {};
    $scope.report = [];

    // Group the results into item groups
    angular.forEach(result.report, function(item) {
      if (!groups[item.itemGroupLabel]) {
        groups[item.itemGroupLabel] = [];
      }
      groups[item.itemGroupLabel].push(item);
    });

    // move into array, for sorting by ng-repeat
    angular.forEach(groups, function(item, index) {
      $scope.report.push({
        label: index,
        items: item
      });
    });

  });
}]);
